import { Message, useDeleteMessageMutation } from '@graphql/generated';

export const useDeleteMessage = () => {
  const [deleteMessage] = useDeleteMessageMutation();

  const deleteMessageById = (
    message: Message,
    onComplete?: () => void,
    onError?: () => void,
  ) => {
    if (!message?.id) return;

    deleteMessage({
      variables: { id: message.id },
      optimisticResponse: {
        deleteMessage: {
          __typename: 'Message',
          id: message.id,
          clientId: message.clientId,
          authorId: message.authorId,
        },
      },
      onCompleted: onComplete,
      onError: onError,
      update(cache, { data }) {
        const deleted = data?.deleteMessage;
        if (!deleted?.clientId) return;
        const cacheId = cache.identify({
          __typename: 'Message',
          clientId: deleted.clientId,
        });
        if (cacheId) cache.evict({ id: cacheId });
      },
    });
  };

  return { deleteMessageById };
};
